export default __webpack_public_path__ + "static/media/hlth.bc2ae410.svg";